import {tns} from "tiny-slider";
function SliderJS() {
    const element = document.querySelectorAll('.slider-js');
    if(element.length > 0) {
        var slider = tns({
            container: '.slider-js',
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayTimeout:3000,
            autoHeight:true,
        });
    }


    const elementMob = document.querySelectorAll('.slider-js-mobile');
    if(elementMob.length > 0) {
        var slider2 = tns({
            container: '.slider-js-mobile',
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayTimeout:3000,
            autoHeight:true,
        });
    }



    const banner = document.querySelectorAll('.banner-js');
    if(banner.length > 0) {
        var sliders_mobile = tns({
            container: '.banner-js',
            items: 1,
            nav:false,
            slideBy: 'page',
            autoplay: false
        });
    }


    const banner_js_desktop = document.querySelectorAll('.banner-js-desktop');
    if(banner_js_desktop.length > 0) {
        var sliders_sd = tns({
            container: '.banner-js-desktop',
            items: 1,
            slideBy: 'page',
            autoplay: false
        });
    }




}

export default SliderJS;